import React from 'react';

import './custom-sizes.less';

const TimeColumn = (props) => {
  const { timeSteps } = props;

  return (
    <div className="time-line-pane right-bordered left-pane">
      {timeSteps &&
        timeSteps.map((el, x) => {
          return (
            <div key={el.key} className={'time-line-row time-step' + (x % 2 != 0 ? ' bottom-bordered' : '')}>
              {x % 2 == 0 ? el.val : ''}
            </div>
          );
        })}
    </div>
  );
};
export default TimeColumn;
